import { useDispatch, useSelector } from "react-redux";
import { SBTaskBoard } from "../../UiComponents/SBTaskBoard"
import { createRef, useEffect, useRef, useState } from "react";
import { sbaAxios } from "../../utils/sbaAxios";
import { DeleteDocument, DownloadDocument, deleteSubTaskAPI, getActivityEntity, getActivityentityType, getTaskDetails, getTaskDocuments, getTaskWithSubTask, getTasks, insertOrUpdateActivityDocument, insertorupdateTask, updateSubTaskAPI, updateTaskComplete } from "../../../config/apiConfig";
import { DateRangePicker } from "rsuite";
import { SBAAutoComplete, SBAComboBox, SBADropDown, SBAMultiSelectCheck } from "../../UiComponents/SBADropDown";
import { SBAEditor } from "../../UiComponents/SBAEditor";
import { SBDatePicker } from "../../UiComponents/SBDatePicker";
import { SBADrawer } from "../../UiComponents/SBADrawer";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { getActivityEntities } from "../../actions/investmentAction";
import { SBNotify } from "../../utils/sbNotify";
import { useCallback } from "react";
import { Modal } from "react-bootstrap";
import { deleteTaskAPI } from "../../../config/apiConfig";
import download from "../../../Images/download.svg"
import { ExcelExportDS } from "../../utils/excelExporter";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-all";
import { SBDateRangePicker } from "../../UiComponents/SBDateRangePicker";

export const TaskBoard = () => {
    const Gstate = useSelector((state) => state) || {};
    const taskTypeDD = Gstate?.tasks?.taskType || [];
    const userDetails = Gstate.common.userDetails.UserId | 0;
    const taskAssignees = Gstate?.tasks?.taskAssignee || [];


    const currentDate = new Date();
    const threeMonthsAgo = new Date(currentDate);
    threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1)

    const [taskType, setTaskType] = useState([]);
    const [taskDateRange, setTaskDateRange] = useState([threeMonthsAgo, currentDate])
    const [taskData, setTaskData] = useState([]);
    const [filter, setFilter] = useState("");
    const [render, setRender] = useState(true);
    const [showMyTask, setShowMyTask] = useState(false);
    const [updateSubTask, setUpdateSubTask] = useState(false);
    const [subTask, setSubTask] = useState(null);

    const [task, setTask] = useState(null);
    const [updateTask, setUpdatetask] = useState(false);
    const [taskEditMode, setTaskEditMode] = useState(null);
    const [taskFiles, setTaskFiles] = useState([]);


    const [deletTask,setDeleteTask]=useState(false);
    const [showAttachment, setShowAttachment] = useState(false);


    const excelData=taskData.map(task=>({
        TaskName:task.TaskName,
        TaskType:task.TaskType,
        TaskBody: htmlDecoder(task?.TaskBody),
        AssignedToUserName:task.AssignedToUserName,
        CompletedDate:task?.CompletedDate ?  moment(task?.CompletedDate).format('MM/DD/YYYY') : "",
        DueDateTime: task?.DueDateTime ?  moment(task?.DueDateTime).format('MM/DD/YYYY') : "",
        ModfiedByUserName:task.ModfiedByUserName,
        AttachmentCount:task.AttachmentCount,
        IsParentTask:true,
        SubTasksList:task?.SubTasksList.map(subTask=>({
            TaskName:subTask?.SubTaskName,
            TaskType:task?.TaskType,
            TaskBody:htmlDecoder(subTask?.SubTaskBody),
            AssignedToUserName:subTask?.AssignedToUserName,
            CompletedDate: subTask?.CompletedDate ?  moment(subTask?.CompletedDate).format('MM/DD/YYYY') : "",
            DueDateTime: subTask?.DueDateTime ?  moment(subTask?.DueDateTime).format('MM/DD/YYYY') : "",
            ModfiedByUserName:subTask?.ModfiedByUserName,
            AttachmentCount:"",
            IsParentTask:false
        }))
    })).flatMap(task=>[task,...task.SubTasksList]);


    const _exporter = createRef();
    
    const excelExport = () => {
        if (_exporter.current) {
            const options = _exporter.current.workbookOptions();
            const rows = options.sheets[0].rows;
            rows.forEach((row) => {
              if (row.type === 'data') {
                if (row.cells[0].value!=='') {
                  row.cells.forEach((cell) => {
                    cell.background = '#E4E4E4';
                    cell.borderTop = { color: '#000000', size: 0.5, style: 'solid' };
                    cell.borderBottom = { color: '#000000', size: 0.5, style: 'solid' };
                    cell.borderLeft = { color: '#000000', size: 0.5, style: 'solid' };
                    cell.borderRight = { color: '#000000', size: 0.5, style: 'solid' };
                  });
                }
              }
            });
            _exporter.current.save(options);
        }
    };

    useEffect(() => {
        const startDate = taskDateRange[0].toISOString();
        const endDate = taskDateRange[1].toISOString();
        const taskTypes = taskType.map(item => item.TaskTypeId).join(',');
        getUpdatedTaskData(startDate, endDate, taskTypes)
    }, [taskType, taskDateRange, render, showMyTask]);

    const edit = (e) => {
        setTaskEditMode("Edit");
        setTask(e.task);
        setUpdatetask(true);
    };
    const markIsCompleted = (ActivityTaskID) => {
        const savecompletedata = {
            "ActivityTaskId": ActivityTaskID,
            "ModifiedByUserId": 0,
        }
        sbaAxios({
            url: `${updateTaskComplete}`,
            method: "post",
            data: savecompletedata,
        }).then((response) => {
        }).catch((error) => {
            console.error(error, "Error While Updating the Completed status");
        });
    }
    const onSearchChange = useCallback((event) => {
        setFilter(event.target.value);
    }, []);
    const getUpdatedTaskData = async (startDate, endDate, taskType) => {
        return await sbaAxios({
            url: `${getTasks}?startDate=${startDate}&endDate=${endDate}&taskTypeIds=${taskType}`,
            method: 'get',
        }).then(res => {
            setTaskData(res.map((c, i) => {
                const status = (c.TaskStatus === "C" || c.IsCompleted) ? "done" : c.SubTasksList.some(task => task.IsCompleted) || c.TaskStatus === "P" ? "inProgress" : "todo";
                return {
                    ...c,
                    id: c.ActivityTaskId,
                    title: c?.TaskName,
                    description: c.TaskBody,
                    status: status,
                    priority: {
                        "color": "none",
                        "priority": "High Priority"
                    },
                    taskType: c.TaskType,
                    SubTasksList: c?.SubTasksList || [],
                }
            }).filter(item => showMyTask ? item.AssignedToUserId === userDetails : item)
            )
        })
    };
    const deletion = (e) => {
        setTaskEditMode("Delete");
        setTask(e.task);
        setDeleteTask(true);
    };
    const attacher = (e) => {
        setTask(e.task);
        setShowAttachment(true);
        // boardAttachment({ data: e.task });
        // setRender(value=>!value)
    };
    const cardOnChange = (data) => {
        const { item, previousItem } = data;
        if (!previousItem.IsCompleted && item.status !== previousItem.status) {
            if (item.status === "done" && !item.IsCompleted) {
                setTaskData(tasks => {
                    return tasks.map(task => {
                        if (task.ActivityTaskId === item.ActivityTaskId) {
                            return { ...task, IsCompleted: true, status: 'done', TaskStatus: 'C' }
                        }
                        else {
                            return task
                        }
                    })
                })

                saveTask({ ...item, IsCompleted: true, status: "done", TaskStatus: "C" }).then(res=>{setRender(value=>!value)});
            }
            else if (item.status === 'todo') {
                setTaskData(tasks => {
                    return tasks.map(task => {
                        if (task.ActivityTaskId === item.ActivityTaskId) {
                            if (!item?.SubTasksList?.some(task => task.IsCompleted))
                                return { ...task, IsCompleted: false, status: 'todo', TaskStatus: 'T' }
                            else
                                return { ...task, IsCompleted: false, status: 'inProgress', TaskStatus: 'P' }
                        }
                        else {
                            return task
                        }
                    })
                });
                if (!item?.SubTasksList?.some(task => task.IsCompleted)) {
                    saveTask({ ...item, IsCompleted: false, status: "todo", TaskStatus: "T" }).then(res=>{setRender(value=>!value)});
                }
            }
            else if (item.status === 'inProgress') {
                setTaskData(tasks => {
                    return tasks.map(task => {
                        if (task.ActivityTaskId === item.ActivityTaskId) {
                            return { ...task, IsCompleted: false, status: 'inProgress', TaskStatus: 'P' };
                        }
                        else {
                            return task
                        }
                    })
                });
                saveTask({ ...item, IsCompleted: false, status: "inProgress", TaskStatus: "P" }).then(res=>{setRender(value=>!value)})
            }

        }
    };
    const editSubTask = (subTask) => {
        setSubTask({ ...subTask })
        setUpdateSubTask(true);
    };
    const updateSTask = (subTask) => {
        ;
        const updatedTask = taskData.map(task => {
            if (subTask.ActivityTaskId === task.ActivityTaskId) {
                task.SubTasksList = task.SubTasksList.map(item => {
                    if (item.ActivitySubTaskId === subTask.ActivitySubTaskId) { return subTask }
                    else return item
                })
                const status = (task.TaskStatus === "C" || task.IsCompleted) ? "done" : task.SubTasksList.some(task => task.IsCompleted) || task.TaskStatus === "P" ? "inProgress" : "todo";
                task.status = status;
            }
            return task
        });
        setTaskData(updatedTask);
        const data = {
            "activitySubTaskId": subTask.ActivitySubTaskId,
            "activityTaskId": subTask.ActivityTaskId,
            "subTaskName": subTask.SubTaskName,
            "subTaskBody": subTask.SubTaskBody || "<></>",
            "assignedToUserId": subTask.AssignedToUserId,
            "assignedToUserName": subTask.AssignedToUserName,
            "modifiedByUserId": subTask.ModifiedByUserId,
            "modfiedByUserName": subTask.ModfiedByUserName || "user name",
            "modifiedDate": new Date().toISOString(),
            "startDateTime": subTask.StartDateTime,
            "dueDateTime": subTask.DueDateTime,
            "isCompleted": subTask.IsCompleted,
            "completedDate": subTask.CompletedDate
        }
        if (data.subTaskName.trim() || data.dueDateTime || data.startDateTime)
            sbaAxios({ url: updateSubTaskAPI, data: data, method: 'post' }).then(() => {
                SBNotify({ Msg: "Sub Task details Updated Successfully" })
            }).catch(e => {
                console.log(e, 'Error updating the Sub Task')
            })
        else
            SBNotify({ Msg: "Please Enter All the Mandatory Fields", type: 'error' })
    };
    const saveSubTask = (subTask) => {
        const updatedTask = taskData.map(task => {
            if (subTask.ActivityTaskId === task.ActivityTaskId) {
                task.SubTasksList = task.SubTasksList.map(item => {
                    if (item.ActivitySubTaskId === subTask.ActivitySubTaskId) { return subTask }
                    else return item
                })
                const status = (task.TaskStatus === "C" || task.IsCompleted) ? "done" : task.SubTasksList.some(task => task.IsCompleted) || task.TaskStatus === "P" ? "inProgress" : "todo";
                task.status = status;
            }
            return task
        });
        setTaskData(updatedTask);
        const data = {
            "activitySubTaskId": subTask.ActivitySubTaskId,
            "activityTaskId": subTask.ActivityTaskId,
            "subTaskName": subTask.SubTaskName,
            "subTaskBody": subTask.SubTaskBody || "<></>",
            "assignedToUserId": subTask.AssignedToUserId,
            "assignedToUserName": subTask.AssignedToUserName,
            "modifiedByUserId": subTask.ModifiedByUserId,
            "modfiedByUserName": subTask.ModfiedByUserName || "user name",
            "modifiedDate": new Date().toISOString(),
            "startDateTime": subTask.StartDateTime,
            "dueDateTime": subTask.DueDateTime,
            "isCompleted": subTask.IsCompleted,
            "completedDate": subTask.CompletedDate
        }
        if (data.subTaskName.trim() || data.dueDateTime || data.startDateTime)
            sbaAxios({ url: updateSubTaskAPI, data: data, method: 'post' }).then(() => {
                SBNotify({ Msg: "Sub Task details Updated Successfully" })
            }).catch(e => {
                console.log(e, 'Error updating the Sub Task')
            })
        else
            SBNotify({ Msg: "Please Enter All the Mandatory Fields", type: 'error' })
        setUpdateSubTask(false);
        setSubTask(null);
    };
    const closeSubTask = () => {
        setUpdateSubTask(false);
        setSubTask(null);
    };
    const removeSubTask = (subTask) => {
        setTaskData(
            taskData.map(task => {
                if (task.ActivityTaskId === subTask.ActivityTaskId) {
                    return { ...task, SubTasksList: task.SubTasksList.filter(task => task.ActivitySubTaskId !== subTask.ActivitySubTaskId) }
                }
                else
                    return task
            })
        );
        sbaAxios({ url: `${deleteSubTaskAPI}${subTask.ActivitySubTaskId}` }).then(res => {
            SBNotify({ Msg: "Sub Task Removed Successfully" })
        }).catch(e => {
            console.log(e, 'Error Deleting the Sub Task');
        })
    };
    const saveTask = async (task) => {
        let ifsave = true;
        const status = (task?.TaskStatus === "C" || task?.IsCompleted) ? "C" : task?.SubTasksList?.some(tas => tas.IsCompleted) || task?.TaskStatus === "P" ? "P" : "T";
        const saveData = {
            "activityId": task?.ActivityId || 0,
            "activityTaskId": task?.ActivityTaskId || 0,
            "taskName": task?.TaskName,
            "taskBody": task?.TaskBody,
            "taskTypeId": task?.TaskTypeId,
            "entityTypeId": task?.EntityTypeId,
            "entityId": task?.EntityId,
            "assignedToUserId": task?.AssignedToUserId,
            "startDateTime": task?.StartDateTime,
            "dueDateTime": task?.DueDateTime,
            "modifiedByUserId": 0,
            "taskStatus": status,
            "isCompleted": status === "C",
        };
        if (!saveData.taskTypeId) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the Activity Type", type: "error" });
        }
        else if (!saveData.assignedToUserId) {
            ifsave = false;
            SBNotify({ Msg: "Please Select the Owner", type: "error" });
        }
        else if (!saveData.taskName) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter Name", type: "error" });
        }
        else if (!saveData.startDateTime) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter the Start Date", type: "error" });
        }
        else if (!saveData.dueDateTime) {
            ifsave = false;
            SBNotify({ Msg: "Please Enter the Due Date", type: "error" });
        }
        if (ifsave) {
            try {
                const resposne = await sbaAxios({
                    url: `${insertorupdateTask}`,
                    method: "post",
                    data: saveData,
                })
                const messsage = saveData.activityTaskId === 0 ? "Task Added Successfully" : "Task Updated Successfully";
                SBNotify({ Msg: messsage, type: "success" });
                if (saveData.taskStatus === "C") {
                    markIsCompleted(saveData.activityTaskId);
                };
                setUpdatetask(false);
                return resposne;
            } catch {
                SBNotify({ Msg: "some error  occured", type: "error" });
            };

        }
    };
    const addSubTaskToTask = (subTask) => {
        if (subTask.SubTaskName.trim()) {
            const data = {
                "activitySubTaskId": subTask.ActivitySubTaskId,
                "activityTaskId": subTask.ActivityTaskId,
                "subTaskName": subTask.SubTaskName,
                "subTaskBody": subTask.SubTaskBody || " ",
                "assignedToUserId": subTask.AssignedToUserId,
                "assignedToUserName": subTask.AssignedToUserName,
                "modifiedByUserId": subTask.ModifiedByUserId,
                "modfiedByUserName": subTask.ModfiedByUserName || "user",
                "modifiedDate": new Date().toISOString(),
                "startDateTime": subTask.StartDateTime,
                "dueDateTime": subTask.DueDateTime,
                "isCompleted": subTask.IsCompleted,
                "completedDate": subTask.CompletedDate
            }
            sbaAxios({ url: updateSubTaskAPI, data: data, method: 'post' }).then((response) => {
                setTaskData(
                    taskData.map(task => {
                        if (task.ActivityTaskId === subTask.ActivityTaskId) {
                            return { ...task, SubTasksList: [...task.SubTasksList, { ...subTask, ActivitySubTaskId: response }] }
                        }
                        else
                            return task
                    })
                );
                SBNotify({ Msg: "Sub Task Added Successfully" })
                return null;
            }).catch(e => {
                console.log(e, 'Error updating the Sub Task')
                return null;
            })
        }
        else {
            SBNotify({ type: 'error', Msg: 'Please Enter Sub Task Name ' })
        };
    };
    const deleteTheTask = async () => {
        try {
            const respo = await deleteSelectedTask(task?.ActivityId);
            SBNotify({ Msg: "Selected Task Deleted Successfully" });
        } catch {
            SBNotify({ Msg: "Selected Task Deleted Successfully", type: 'error' });
        };
        setDeleteTask(false);
        setRender(value => !value);
    };
    const updateDateRange=(e)=>{
        if(e)
        {
            const newStartDate = e.value.start !== null ? e.value.start : taskDateRange[0];
            const newEndDate = e.value.end !== null ? e.value.end : taskDateRange[1];
            setTaskDateRange([newStartDate, newEndDate])
        }
    }
    return <><div className="row">
        <div className="col-md-2">
            <label className="mb-1 label">Select Date Range</label>
            <div >
                <SBDateRangePicker
                value={{start:taskDateRange[0],end:taskDateRange[1]}}
                onChange={(e)=>{updateDateRange(e)}}
                />
            </div>
        </div>
        <div className="col-md-3">
            <label htmlFor="select fund" className="mb-1 label">
                Task Type
            </label>
            <div>
                <SBAMultiSelectCheck
                    className="w-100"
                    data={taskTypeDD}
                    value={taskType}
                    dataItemKey="TaskTypeId"
                    textField="TaskType"
                    onChange={(e) => { setTaskType(e.value) }}
                    tags={
                        taskType?.length > 0
                            ? [
                                {
                                    text: `${taskType?.length} items selected`,
                                    data: [...taskType],
                                },
                            ]
                            : []
                    }
                />
            </div>
        </div>
        <div className="col-md-2">
            <label htmlFor="select fund" className="mb-1 label">
                Search Task
            </label>
            <input
                placeholder="Search Task..."
                className="form-control"
                onChange={onSearchChange}
                value={filter}
            />
        </div>
        <div className="col-md-2 row-items">
            <div className="p-2"><input className="p-4" type="checkbox" checked={showMyTask} onChange={() => { setShowMyTask(value => !value) }} /><label className="label ms-2">Show My Task</label></div>
        </div>
        <div className="col-md-3 d-flex justify-content-end row-items">
            <button
                type="submit"
                className="p-sm-btn mx-1"
                disabled={false}
                onClick={() => { setUpdatetask(true); setTaskEditMode("Add"); setTask(null); setTaskFiles([]); }}
            >
                <i className="fa-solid fa-plus" /> Add
            </button>
            <button
                type="submit"
                className="p-sm-btn mx-1"
                disabled={false}
                onClick={() => { excelExport() }}
            >
                <img src={download} /> Export
            </button>
        </div>
    </div>
        <SBTaskBoard
            data={taskData}
            deleteTask={deletion}
            editTask={edit}
            attachment={attacher}
            cardOnChange={(e) => { cardOnChange(e) }}
            filter={filter}
            editSubTask={editSubTask}
            setTaskData={setTaskData}
            taskData={taskData}
            removeSubTask={removeSubTask}
            addSubTaskToTask={addSubTaskToTask}
            updateSubTask={updateSTask}
            ownerList={taskAssignees}
        />
        <SBADrawer
            open={updateSubTask}
            setOpen={setUpdateSubTask}
            title={"Update Sub Task"}
        >
            <SubTaskEditor subTask={subTask} saveSubTask={saveSubTask} closeSubTask={closeSubTask} />
        </SBADrawer>
        <SBADrawer
            open={updateTask}
            setOpen={setUpdatetask}
            title={"Insert/Update Task"}
        >
            <TaskEditor document={taskFiles} task={task} saveTask={saveTask} setRender={setRender} closeTask={() => { setUpdatetask(false); setRender(value => !value); }} mode={taskEditMode} />
        </SBADrawer>
        <AttachmentModal showModal={showAttachment} closeModal={() => { setShowAttachment(false); setRender(value => !value); }} task={task} />
        <DeleteTaskModal showModal={deletTask} closeModal={() => { setDeleteTask(false) }} deleteTask={deleteTheTask} />
        <DeleteAttachmentModal showModal={false}/>
        <DataExcelExport excelData={excelData} exporter={_exporter}/>
    </>
};
const SubTaskEditor = ({ subTask, saveSubTask, closeSubTask }) => {
    const Gstate = useSelector(state => state);
    const taskAssignees = Gstate?.tasks?.taskAssignee || [];
    const [task, setTask] = useState(subTask);
    const [bodyContent, setBodyContent] = useState(subTask?.SubTaskBody);
    useEffect(() => {
        setBodyContent(subTask?.SubTaskBody);
        setTask(subTask);
    }, [subTask])
    const updateSubTaskName = (e) => {
        const text = e?.target?.value || '';
        setTask(value => ({ ...value, SubTaskName: text, title: text }));
    }
    const udpateSubTask = () => {
        saveSubTask(task)
    };
    const updateOwner = (e) => {
        if (e.value) {
            setTask(task => ({ ...task, ...e.value }));
        }
    };
    const updateStartDate = (e) => {
        setTask(task => ({ ...task, StartDateTime: e.toISOString() }))
    };
    const updateDueDate = (e) => {
        setTask(task => ({ ...task, DueDateTime: e.toISOString() }))
    };
    const updateIsComplete = (e) => {
        setTask(task => ({ ...task, IsCompleted: !task.IsCompleted }))
    };
    const updateBodyContent = (e) => {
        setBodyContent(e.html);
        setTask(task => ({ ...task, SubTaskBody: e.html }));
    }
    return <>
        <div className="mb-4">
            <label className="header-container m-1"><b>Name: </b></label>
            <div>
                <input className="form-control w-75" type="text" value={task?.SubTaskName} onChange={(e) => { updateSubTaskName(e) }} />
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1"><b>Owner: </b></label>
            <div>
                {/* <input className="form-control w-75" type="text" value={task.ownerName} onChange={(e)=>{setTask(value=>({...value,ownerName:e?.target?.value || ''}))}}/> */}
                <SBAComboBox
                    data={taskAssignees}
                    value={{ AssignedToUserId: task?.AssignedToUserId, AssignedToUserName: task?.AssignedToUserName }}
                    textField={"AssignedToUserName"}
                    valueField={"AssignedToUserId"}
                    onChange={updateOwner}
                    className="w-75"
                    popupSettings={{ className: "modalDD" }}
                />
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Start Date: </b>
            </label>
            <div>
                <SBDatePicker
                    className="w-75"
                    value={task?.StartDateTime ? moment(task?.StartDateTime) : null}
                    onChange={updateStartDate}
                ></SBDatePicker>
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Due Date: </b>
            </label>
            <div>
                <SBDatePicker
                    className="w-75"
                    value={task?.DueDateTime ? moment(task?.DueDateTime) : null}
                    onChange={updateDueDate}
                ></SBDatePicker>
            </div>
        </div>
        <div className="p-2">
            <input
                className="p-4"
                type="checkbox"
                checked={task?.IsCompleted}
                onChange={updateIsComplete}
            />
            <label className="label ms-2">Is Completed</label>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Body:</b>
            </label>
            <div>
                <SBAEditor onChange={updateBodyContent} defaultContent={bodyContent} editorHeight={300} setContent={setBodyContent} />
            </div>
        </div>
        <div className="d-flex ">
            <button className="s-sm-btn mx-1" onClick={closeSubTask}>Cancel</button>
            <button className="p-sm-btn mx-1" onClick={udpateSubTask}> Update</button>
        </div>
    </>
};
const TaskEditor = ({ task, saveTask, closeTask, mode ,setRender }) => {
    const Gstate = useSelector(state => state);
    const taskType = Gstate?.tasks?.taskType || [];
    const taskAssignees = Gstate?.tasks?.taskAssignee || [];
    const [localTask, setLocalTask] = useState(task);
    const [bodyContent, setBodyContent] = useState(task?.TaskBody);
    const [accountList, setAccountList] = useState([]);
    const [contactList, setContactList] = useState([]);
    const [fileList, setFileList] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const setAccountAndContactList=async()=>{
        try {
         const  contactList= await getEntityDataWithoutTerm(0,2);
           const accountList=await getEntityDataWithoutTerm(1,2);
           setAccountList(accountList);
           setContactList(contactList);
        } catch (error) {
            
        }
    }
    useEffect(()=>{
        setAccountAndContactList();
    },[]);
    useEffect(() => {
        const fetchData = async () => {
            setLocalTask(task);
            setBodyContent(task?.TaskBody);
            if (task?.ActivityId) {
                try {
                    const documents = await getDocumentList(task?.ActivityId);
                    setFileList(documents);
                } catch (error) {
                    console.log("Error fetching document list:", error);
                    setFileList([]);
                }
            } else {
                setFileList([]);
            }
        };

        fetchData();

        return () => {

        };
    }, [task]);
    const updateBodyContent = (e) => {
        setBodyContent(e.html);
        setLocalTask(task => ({ ...task, TaskBody: e.html }));
    };
    const getEntityData = async (entityType, searchTerms, activitySourceId) => {
        try {
            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${entityType}&SearchString=${searchTerms}&activitySourceId=${activitySourceId}`
            });
            return response;
        } catch (error) {
            console.error("Error fetching entity data:", error);
            throw error; // Propagate the error for the caller to handle
        }
    };
    const getEntityDataWithoutTerm = async (entityType,  activitySourceId) => {
        try {
            const response = await sbaAxios({
                url: `${getActivityEntity}ActivityEntityTypeIds=${entityType}&activitySourceId=${activitySourceId}`
            });
            return response;
        } catch (error) {
            console.error("Error fetching entity data:", error);
            throw error; // Propagate the error for the caller to handle
        }
    };
    const getContactList = async (e) => {
        const term = e?.filter?.value || "";
        if (term.length > 1) {
            try {
                const data = await getEntityData(0, term, 2);
                return [];
                setContactList(data);
            } catch (error) {
                console.error("Error fetching contact list:", error);
            }
        }
    };
    const getAccountList = async (e) => {
        const term = e?.filter?.value || "";
        if (term.length > 1) {
            try {
                const data = await getEntityData(1, term, 2);
                setAccountList(data);
            } catch (error) {
                console.error("Error fetching Account list:", error);
            }
        }
    };
    const handleFileChange = (event) => {
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
            const updatedFiles = [...fileList];
            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;
                const lastDotIndex = fileName.lastIndexOf('.');
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                const reader = new FileReader();
                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = fileList.length + i;
                        updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                        setFileList([...fileList, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex, base64String }]);
                    }
                };
                reader.readAsArrayBuffer(file);
            }
        }
    };
    const handleDeleteClick = (props) => {
        if (props?.data?.DocumentId !== 0) {
            setDeleteModal(true);
            setSelectedDocument(props.data);
        }
        else {
            const updatedFiles = fileList.filter((item, index) => item.rowIndex !== props.data.rowIndex);
            setFileList(updatedFiles);
        }

    };
    const deleteAttachment = () => {
        sbaAxios({
            url: `${DeleteDocument}${localTask.ActivityId},${selectedDocument.DocumentId}`
        })
            .then((res) => {
                const updatedFiles = fileList.filter((item, index) => item.DocumentId !== selectedDocument.DocumentId);
                setFileList(updatedFiles);
                setDeleteModal(false);
            })
            .catch((error) => {
                SBNotify({ Msg: error, type: "error" });
            });
    };
    const closeModal = () => {
        setDeleteModal(false)
    };
    const saveOrInsertTask = () => {
        const startDate = localTask?.StartDateTime;
        saveTask(localTask).then(activityId => {
            if (localTask?.TaskTypeId && localTask?.AssignedToUserId && localTask?.TaskName && localTask?.StartDateTime && localTask?.DueDateTime)
                updateDocument(fileList.filter(docu => docu.base64String), activityId, startDate).then(resposne=>{
                    setRender(value => !value);
                });
        });
    };
    return <>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Activity Type:</b>
            </label>

            <div>
                <SBADropDown
                    className="w-50"
                    textField={"TaskType"}
                    valueField={"TaskTypeId"}
                    data={taskType}
                    value={taskType.find(type => type.TaskTypeId === localTask?.TaskTypeId)}
                    popupSettings={{ className: "modalDD" }}
                    disabled={mode === "Edit"}
                    onChange={(e) => { setLocalTask(task => ({ ...task, TaskTypeId: e.value.TaskTypeId, TaskType: e.value.TaskType })) }}
                />
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Owner:</b>
            </label>
            <div>
                <SBADropDown
                    className="w-50"
                    textField={"AssignedToUserName"}
                    valueField={"AssignedToUserId"}
                    data={taskAssignees}
                    value={taskAssignees.find(assigne => assigne.AssignedToUserId === localTask?.AssignedToUserId)}
                    popupSettings={{ className: "modalDD" }}
                    onChange={(e) => { setLocalTask(task => ({ ...task, AssignedToUserId: e.value.AssignedToUserId, AssignedToUserName: e.value.AssignedToUserName })) }}
                />
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Name: </b>
            </label>
            <div>
                <input
                    className="form-control w-50"
                    type="text"
                    value={localTask?.TaskName}
                    onChange={(e) => { setLocalTask(task => ({ ...task, TaskName: e?.target?.value || "" })) }}
                />
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Start Date: </b>
            </label>
            <div>
                <SBDatePicker
                    className="w-50"
                    value={localTask?.StartDateTime ? moment(localTask?.StartDateTime) : null}
                    onChange={(e) => { setLocalTask(task => ({ ...task, StartDateTime: e?.toISOString() || "" })) }}
                ></SBDatePicker>
            </div>
        </div>
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Due Date: </b>
            </label>
            <div>
                <SBDatePicker
                    className="w-50"
                    id="DueDate"
                    value={localTask?.DueDateTime ? moment(localTask?.DueDateTime) : null}
                    onChange={(e) => { setLocalTask(task => ({ ...task, DueDateTime: e?.toISOString() || "" })) }}
                ></SBDatePicker>
            </div>
        </div>
        {mode === "Edit" && (
            <div className="p-2">
                <input
                    className="p-4"
                    type="checkbox"
                    checked={localTask?.IsCompleted}
                    onChange={(e) => { setLocalTask(task => ({ ...task, IsCompleted: e.target.checked })) }}
                />
                <label className="label ms-2">Is Completed</label>
            </div>
        )}
        <div className="mb-4">
            <label className="header-container m-1">
                <b>Body:</b>
            </label>
            <div>

                <SBAEditor
                    onChange={updateBodyContent}
                    defaultContent={bodyContent}
                    editorHeight={300}
                    setContent={setBodyContent}
                />

            </div>
        </div>
        <div className="mb-4">
            <div className="d-flex align-items-center gap-5">
                <div className="form-check">
                    <input
                        type="radio"
                        className="form-check-input"
                        name="table-options"
                        id = "contact"
                        value = "contact"
                        checked={localTask?.EntityTypeId === 0}
                        //disabled={mode === "Edit"}
                        onChange={() => { setLocalTask(task => ({ ...task, EntityTypeId: 0 ,EntityId:0, EntityName:'' })) }}
                    />
                    <label htmlFor="asset" className="form-check-label">
                        Contacts
                    </label>
                </div>
                <div className="form-check ms-3">
                    <input
                        type="radio"
                        className="form-check-input"
                        name="table-options"
                        checked={localTask?.EntityTypeId === 1}
                        //disabled={mode === "Edit"}
                        onChange={() => { setLocalTask(task => ({ ...task, EntityTypeId: 1 ,EntityId:0, EntityName:'' })) }}
                    />
                    <label htmlFor="group" className="form-check-label">
                        Accounts
                    </label>
                </div>
                {(localTask?.EntityTypeId === 0) && <SBAComboBox
                    data={contactList}
                    onChange={(e) => { setLocalTask(task => ({ ...task, EntityId: e?.value?.EntityId, EntityName: e?.value?.EntityName })) }}
                    textField="EntityName"
                    popupSettings={{className: 'modalDD' }}
                    valueField={"EntityId"}
                    value={{ EntityId: localTask?.EntityId, EntityName: localTask?.EntityName }}
                    //onFilterChange={getContactList}
                />}
                {localTask?.EntityTypeId === 1 && <SBAComboBox
                    data={accountList}
                    onChange={(e) => { setLocalTask(task => ({ ...task, EntityId: e?.value?.EntityId, EntityName: e?.value?.EntityName })) }}
                    textField="EntityName"
                    popupSettings={{ className: 'modalDD' }}
                    valueField={"EntityId"}
                    value={{ EntityId: localTask?.EntityId, EntityName: localTask?.EntityName }}
                    // onFilterChange={getAccountList}
                />}
               
            </div>

        </div>
        <div className="row mb-2">
            <div style={{ position: "relative" }}>
                <input
                    type="file"
                    id="fileInput"
                    className="input-hidden"
                    onChange={handleFileChange}
                />
            </div>
        </div>

        <div className="row mb-2">
            <AttachmentGrid GridData={fileList} deleteAttachment={handleDeleteClick} />
        </div>
        <div className="mt-4">
            <button className="s-sm-btn mx-1" onClick={closeTask}>
                Cancel
            </button>
            <button className="p-sm-btn mx-1" onClick={() => { saveOrInsertTask() }}>
                Save
            </button>
        </div>
        <DeleteAttachmentModal deleteAttachment={deleteAttachment} showModal={deleteModal} closeModal={closeModal} />
    </>
};
const DeleteAttachmentModal = ({ showModal, closeModal, deleteAttachment }) => {
    return <Modal show={showModal}>
        <Modal.Header
            closeButton
            onClick={closeModal}
        >
            <Modal.Title>
                Do you want to delete the selected Document?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Document will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
            <button
                className="s-sm-btn mx-1"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="p-sm-btn mx-1"
                onClick={deleteAttachment}
            >
                Yes
            </button>
        </Modal.Footer>
    </Modal>
};
export const AttachmentModal = ({ showModal, closeModal, task }) => {
    const [fileList, setFileList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedAttachment, setSelectedAttchment] = useState(null);

    useEffect(()=>{
        const fetchData = async () => {
            if (task?.ActivityId) {
                try {
                    const documents = await getDocumentList(task?.ActivityId);
                    setFileList(documents);
                } catch (error) {
                    console.log("Error fetching document list:", error);
                    setFileList([]);
                }
            } else {
                setFileList([]);
            }
        };

        fetchData();

        return () => {

        };
    },[task]);
    const handleFileChange = (event) => {
        const newFiles = event.target.files;
        if (newFiles.length > 0) {
            const updatedFiles = [...fileList];
            for (let i = 0; i < newFiles.length; i++) {
                const file = newFiles[i];
                const fileName = file.name;
                const lastDotIndex = fileName.lastIndexOf('.');
                const extension = lastDotIndex >= 0 ? fileName.substring(lastDotIndex + 1) : '';
                const reader = new FileReader();
                reader.onload = function () {
                    if (reader.result) {
                        const arrayBuffer = reader.result;
                        const base64String = arrayBufferToBase64(arrayBuffer);
                        const rowIndex = fileList.length + i;
                        const newdoc={ DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex, base64String };
                        updatedFiles.push({ file, fileName, extension, base64String, rowIndex });
                        setFileList(fileList=>([...fileList, { DocumentId: 0, DocumentName: fileName, DocumentExtension: extension, rowIndex, base64String }]));
                        if(task?.ActivityId && task?.StartDateTime) {
                            updateDocument([newdoc], task?.ActivityId, task?.StartDateTime);
                        }
                    }
                };
                reader.readAsArrayBuffer(file);
            }


        }
    };
    const deleteSelectedAttachment = () => {
        sbaAxios({
            url: `${DeleteDocument}${task.ActivityId},${selectedAttachment.DocumentId}`
        })
            .then((res) => {
                const updatedFiles = fileList.filter((item, index) => item.DocumentId !== selectedAttachment.DocumentId);
                setFileList(updatedFiles);
                setShowDeleteModal(false);
            })
            .catch((error) => {
                SBNotify({ Msg: error, type: "error" });
            });
    };
    const handleDeleteClick = (props) => {
        if (props?.data?.DocumentId !== 0) {
            setShowDeleteModal(true);
            setSelectedAttchment(props.data);
        }
        else {
            const updatedFiles = fileList.filter((item, index) => item.rowIndex !== props.data.rowIndex);
            setFileList(updatedFiles);
        }

    };
    return (<>
        <DeleteAttachmentModal showModal={showDeleteModal} closeModal={() => { setShowDeleteModal(false) }} deleteAttachment={deleteSelectedAttachment} />
        <Modal show={showModal}>
            <Modal.Header closeButton onClick={closeModal}>
                <Modal.Title>Attachment Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <AttachmentGrid GridData={fileList} deleteAttachment={handleDeleteClick} />
            </Modal.Body>
            <Modal.Footer>
                <div className="row" style={{ marginTop: "10px" }}>
                    <div style={{ position: "relative" }}>
                        <input
                            type="file"
                            id="fileInput"
                            className="input-hidden"
                            onChange={handleFileChange}
                        />
                    </div>
                </div>
                <button className="s-sm-btn mx-1" onClick={closeModal}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>

    </>
    );
};
const DeleteTaskModal = ({ showModal, closeModal, deleteTask }) => {
    return <Modal show={showModal}>
        <Modal.Header
            closeButton
            onClick={closeModal}
        >
            <Modal.Title>
                Do you want to delete the selected Task?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Task will be deleted permanently. Are you sure?</p>
        </Modal.Body>
        <Modal.Footer>
            <button
                className="s-sm-btn mx-1"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="p-sm-btn mx-1"
                onClick={deleteTask}
            >
                Yes
            </button>
        </Modal.Footer>
    </Modal>
};
const AttachmentGrid = ({ GridData, deleteAttachment }) => {

    const AttachDeleteButtonRenderer = (props) => {
        return (
            <div className="actions-cell">
                <i
                    className="fas fa-trash"
                    style={{ color: "#DF001B", margin: "0 8px", cursor: "pointer" }}
                    onClick={() => { deleteAttachment(props) }}
                ></i>
            </div>
        );
    };
    const fileColDef = [
        {

            field: "DocumentName",
            headerName: "File Name",
            sort: "asc",
            filter: "agTextColumnFilter",
            cellRenderer: AttachmentCellRenderer,
            tooltipField: 'FileName',
            flex: 1,
        },
        {
            field: "DocumentExtension",
            headerName: "Extension",
            maxWidth: 100,
            cellRenderer: iconRenderer,
            pinned: 'right',
        },
        {
            headerName: "Delete",
            field: "",
            cellRenderer: AttachDeleteButtonRenderer,
            pinned: 'right',
            maxWidth: 100

        }
    ];
    return <div
        className="ag-theme-alpine"
        style={{ height: "200px" }}
    >
        <AgGridReact
            columnDefs={fileColDef}
            rowData={GridData}
            defaultColDef={{
                sortable: true,
                flex: 1,
                resizable:true
            }}
            overlayNoRowsTemplate={`<span>${"No data Available"}</span>`}
        ></AgGridReact>
    </div>
};
const deleteSelectedTask = async (activityId) => {
    try {
        const res = sbaAxios({ url: deleteTaskAPI + activityId });
        return res;
    } catch (e) {
        console.log(e, 'Error While Deleting the Selected Task');
        return true;
    }
};
const updateDocument = async (docuList, activityId, startDate) => {
    const DocumentData = docuList.map((obj) => {
        return {
            ActivityId: activityId,
            DocumentId: 0,
            DocumentName: obj.DocumentName,
            DocumentContent: obj.base64String,
            DocumentExtension: obj.DocumentExtension,
            DocumentDate: startDate,
            RuleId: 0,
            IsPartnerLetter: false,
            IsEmailForwarded: false,
            IsReturnsProcessed: false,
            IsManagerLetter: false,
            ModifiedBy: 0,
            ActivitySourceId: 1
        };
    });
    if (docuList.length > 0){
        try {
            await sbaAxios({
                url: `${insertOrUpdateActivityDocument}`,
                method: "post",
                data: DocumentData,
            })
            return true;
        } catch (error) {
            console.error(error, 'Error UpLoading files');
            return false;
        }
    }
};
const getDocumentList = async (activityId) => {
    try {
        const response = await sbaAxios({ url: getTaskDocuments + activityId });
        return response;
    }
    catch {
        return [];
    }
};
const arrayBufferToBase64 = (arrayBuffer) => {
    const binary = [];
    const bytes = new Uint8Array(arrayBuffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary.push(String.fromCharCode(bytes[i]));
    }
    return btoa(binary.join(''));
};
const AttachmentCellRenderer = (params) => {
    const documentName = params.data.DocumentName;
    return <span onClick={() => pdfview(params)}>{documentName}</span>;
};
const Attachopen = (params) => {
    const selectedFile = params.data;
    if (selectedFile) {
        const dataUrl = `data:application/pdf;base64,${selectedFile.base64String}`;
        const newWindow = window.open('', '_blank');
        newWindow.document.write("<iframe width='100%' height='100%' src='" + dataUrl + "'></iframe>");
    }
};
const pdfview = (params) => {
    try {
        const documentId = params.data.DocumentId;
        const documentName = params.data.DocumentName;
        const fileExtension = params.data.DocumentExtension.toLowerCase();

        const urlBuild = DownloadDocument + btoa(documentId.toString());      
        sbaAxios({ url: urlBuild }).then((response) => {
            if (fileExtension === "pdf") {
                window.open(urlBuild)
            } else {
                const link = document.createElement("a");
                link.href = URL.createObjectURL(response);
                link.download = documentName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });
    } catch (error) {
        console.error("Error opening document:", error);
    }
};
const iconRenderer = (params) => {
    const fileExtension = params.data.DocumentExtension;
    return <span>{getFileIcon(fileExtension)}</span>;
};
const getFileIcon = (fileExtension) => {
    switch (fileExtension.toLowerCase()) {
        case "pdf":
            return <i class="far fa-file-pdf" style={{ color: "red" }}></i>;
        case "xlsx":
            return <i class="far fa-file-excel" style={{ color: "green" }}></i>;
        default:
            return <span>&#x1F4C4;</span>;
    }
};
const getDateFormatted = (isoDate) => {
    return isoDate ? moment(isoDate).format("MM-DD-YYYY") : "";
};
const DataExcelExport=({excelData,exporter})=>{
    return  <ExcelExport
    data={excelData}
    // group={group}
    collapsible={true}
    fileName="TaskBoard.xlsx"
    ref={exporter}
  >
     <ExcelExportColumn field="AttachmentCount" title="Attachment Count" />
    <ExcelExportColumn field="TaskName" title="Task Name" width={200} />
    <ExcelExportColumn field="TaskType" title="Task Type" />
    <ExcelExportColumn field="TaskBody" title="description" />
    <ExcelExportColumn field="CompletedDate" title="Completed Date" />
    <ExcelExportColumn field="DueDateTime" title="Due Date" />
    <ExcelExportColumn field="AssignedToUserName" title="Assigned User Name" />
    <ExcelExportColumn field="ModfiedByUserName" title="Modified User Name" />
    <ExcelExportColumn field="IsParentTask" title="Parent Task" hidden />
  </ExcelExport>
}

export const htmlDecoder = (tag) => {
    try {
        const input=tag || '<p></p>';
        const decodedValue = decodeURIComponent(input);
        const cleanedValue = decodedValue.replace(/<[^>]+>|&bull;|&rsquo;/g, '');
        return cleanedValue;
    }
    catch{
        return '';
    }
   
}

